import { useState, useEffect } from "react"
import { useHistory } from "react-router-dom"
import { OverviewUtilizationCard } from "../atoms"
import { GreenUpArrow, Steps, redDownArrow } from "../../../assets/images"
import { handleAppError } from "../../handlers"
import { OverviewApi } from "../../../services"
import { commaingNumber } from "../../../utils"
import { SemiDonughnutGraph } from "../molecules"
import { SpinnerDotted } from "../../common/atoms"

const StepsCard = ({ contractId, startDate, endDate, totalCustomerCount = 0, classes = '' }) => {
  const [state, setState] = useState({ loading: true })
  const history = useHistory()

  useEffect(() => {
    if(!contractId) return

    setState(prevState => { return {...prevState, loading: true} })
    OverviewApi.fetchStepsOverview({ contract_id: contractId, start_date: startDate, end_date: endDate },
      (res) => {
        setState({...res.data, loading: false})
      },
      (err) => handleAppError(err)
    )
  }, [contractId])

  const { sponsored = false, average_steps_per_day = 0, average_steps_per_month = 0, employee_sync_count = 0,
          avgerage_steps_increase_percentage = 0, steps_increase_percentage = 0, loading } = state
  const stepsPerIncreased = steps_increase_percentage > 0
  const avgStepsPerIncreased = avgerage_steps_increase_percentage > 0
  const stepsPerIncrease = steps_increase_percentage.toString().replace(/-/g, '')
  const avgStepsPerIncrease = avgerage_steps_increase_percentage.toString().replace(/-/g, '')

  return (
    <div className={`bg-white border border-gray-200 rounded-lg p-6 ${classes}`}>
      <div className='flex justify-between items-center'>
        <div className='flex items-center gap-3'>
          <img className='h-8 w-8' src={Steps} alt='steps' />
          <div className="flex flex-row gap-4">
            <span className={`text-base font-semibold text-gray-700 leading-none flex gap-4`}>{'Steps'}</span>
            { sponsored && <span className='text-white inline-block text-xs rounded-full px-2 py-1 -mt-1 bg-green-1000'>Sponsored</span>}
          </div>
        </div>
        <div className='text-base text-blue-600'>
          <button 
            className='border border-gray-275 rounded-md bg-white px-6 py-2 font-semibold'
            onClick={() => '/steps' && history.push('/steps')}
          >
            View insights
          </button>
        </div>
      </div>
      { !loading ?
          <div className='grid grid-cols-3 gap-6 mt-6'>
            <div className='flex flex-col'>
              <h3 className='text-gray-500 text-xs font-semibold tracking-wider'>{'EMPLOYEES WHO SYNCED STEPS'}</h3>
              <SemiDonughnutGraph linerStyles={employee_sync_count?.toString().length > 5 ? 'w-7/12 text-center bottom-6' : 'bottom-11'} id='steps-myChart' total={totalCustomerCount} completed={employee_sync_count} title='step utilization' liner={<span><span className='font-semibold text-sm'>{employee_sync_count}</span> out of {totalCustomerCount} employees</span>} graphClasses='-mt-8 -mb-4' classes='mt-2' metricValue="*includes only active employees"/>
            </div>
            <div className='flex flex-col'>
              <h3 className='text-gray-500 text-xs font-semibold tracking-wider'>{'MONTHLY STEPS TAKEN'}</h3>
              <OverviewUtilizationCard 
                title={
                  <span className="flex flex-row text-3xl font-semibold text-gray-900">
                    {commaingNumber(parseInt(average_steps_per_month, 10))} 
                    {<>
                        <img className='h-3 w-3 ml-1.5 mb-0 mt-4' src={stepsPerIncreased ? GreenUpArrow : redDownArrow} />
                        <span className="font-semibold text-xs mt-4 ml-1" style={{ color: stepsPerIncreased ? '#00A04F' : '#C54B4F', marginTop: '0.86rem' }}>{stepsPerIncrease}%</span>
                    </>}
                  </span>
                }
                liner={'Steps / month'}
                classes='flex-1 mt-2' 
              />
            </div>
            <div className='flex flex-col'>
              <h3 className='text-gray-500 text-xs font-semibold tracking-wider'>{'AVERAGE STEPS TAKEN PER DAY'}</h3>
              <OverviewUtilizationCard 
                title={
                  <span className="flex flex-row text-3xl font-semibold text-gray-900">
                    {commaingNumber(parseInt(average_steps_per_day, 10))}
                    {<>
                      <img className='h-3 w-3 ml-1.5 mb-0 mt-4' src={avgStepsPerIncreased ? GreenUpArrow : redDownArrow} />
                      <span className="font-semibold text-xs mt-4 ml-1" style={{ color: avgStepsPerIncreased ? '#00A04F' : '#C54B4F', marginTop: '0.86rem' }}>{avgStepsPerIncrease}%</span>
                    </>}
                  </span>
                }
                liner={'Average steps / day'} classes='flex-1 mt-2' />
            </div>
          </div> :
          <div className='h-40 flex items-center justify-center'><SpinnerDotted /></div>
      }
    </div>
  )
}

export default StepsCard